var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 43,
    viewBox: "0 0 34 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8354 1.18198L0.616831 24.8576C0.259468 25.3489 0.208051 25.9993 0.483759 26.5407C0.759466 27.0821 1.31566 27.423 1.92324 27.423H13.2309V40.8845C13.2309 41.5842 13.6813 42.2043 14.3467 42.4207C15.0121 42.6371 15.7411 42.4005 16.1527 41.8346L33.3833 18.1424C33.7407 17.6511 33.7921 17.0007 33.5164 16.4593C33.2407 15.9179 32.6845 15.577 32.0769 15.577H20.7693V2.11549C20.7693 2.08338 20.7684 2.05149 20.7665 2.01985M17.906 1.08966C17.8814 1.11955 17.8579 1.15035 17.8354 1.18198L17.906 1.08966ZM18.4207 0.675698C18.2273 0.773999 18.0512 0.912702 17.906 1.08966L18.4207 0.675698ZM19.0583 0.502902C18.8298 0.516244 18.614 0.577084 18.4207 0.675698L19.0583 0.502902ZM19.6537 0.578918C19.4596 0.515739 19.2575 0.490971 19.0583 0.502902L19.6537 0.578918ZM20.1798 0.867583C20.0257 0.740803 19.8478 0.641994 19.6537 0.578918L20.1798 0.867583ZM20.5937 1.38231C20.4954 1.18888 20.3567 1.01278 20.1798 0.867583L20.5937 1.38231ZM20.7665 2.01985C20.7532 1.79134 20.6923 1.57558 20.5937 1.38231L20.7665 2.01985ZM17.5385 7.08307L5.09547 24.1923H14.8463C15.7384 24.1923 16.4616 24.9155 16.4616 25.8077V35.9169L28.9047 18.8077H19.1539C18.2618 18.8077 17.5385 18.0845 17.5385 17.1923V7.08307Z",
    fill: "#7043FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLightning);
export default __webpack_public_path__ + "static/media/purple_lightning.703ceb6c592553d72ba74730984f9b7d.svg";
export { ForwardRef as ReactComponent };